<!-- チャット画面 -->
<p-dialog
  [(visible)]="chatModal"
  [draggable]="false"
  [closable]="false"
  styleClass="chat-dialog"
  position="bottom-right"
>
  <!-- ヘッダー -->
  <ng-template pTemplate="header">
    <div class="header-botton p-d-flex p-jc-end">
      <!-- 閉じるボタン -->
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-times"
        class="p-button-sm p-button-rounded p-button-outlined"
        (click)="close()"
      ></button>
    </div>
  </ng-template>

  <!-- コンテンツ -->
  <div class="content" [class.platform-large-text]="getTextSize()">
    <p-accordion>
      <p-accordionTab [selected]="true">
        <ng-template pTemplate="header">
          <div class="header">公開掲示板（全会員公開）</div>
        </ng-template>
        <ng-template pTemplate="content">
          <!-- 注意文言 -->
          <div class="warning-text">
            ※課題等について質問を投稿できます<br />
            ※投稿した団体名称が公開されます<br />
            ※課題・ソリューションの登録者へ投稿の通知がされます
          </div>
          <!-- チャットコンテンツ -->
          <div class="chat-content">
            <p-scrollPanel>
              <!-- チャットブロック -->
              <div
                class="chat-block"
                *ngFor="let chatComment of chatCommentList"
              >
                <!-- チャットブロック(自身) -->
                <div
                  class="private-chat-block"
                  *ngIf="
                    !decisionSecretariat() &&
                    decisionPerspective(chatComment.member_id) &&
                    (1 == chatComment.status || 2 == chatComment.status)
                  "
                >
                  <div class="p-d-flex p-jc-between name">
                    <div class="p-d-flex">
                      {{ chatComment.organization_name }}
                      <div class="datetime">
                        {{ chatComment.create_datetime }}
                      </div>
                    </div>
                    <div>
                      <!-- 投稿削除ボタン -->
                      <button
                        pButton
                        type="button"
                        label="削除"
                        class="delete-button"
                        (click)="delete(chatComment.board_id)"
                        *ngIf="decisionSecretariat()"
                      ></button>
                    </div>
                  </div>
                  <div class="chat-comment">
                    {{ chatComment.board_comment }}
                  </div>
                </div>
                <!-- チャットブロック(相手) -->
                <div
                  class="public-chat-block"
                  *ngIf="
                    (decisionSecretariat() ||
                      !decisionPerspective(chatComment.member_id)) &&
                      (1 == chatComment.status || 2 == chatComment.status)
                  "
                >
                  <div class="p-d-flex p-jc-between name">
                    <div class="p-d-flex">
                      <a href="javascript:void(0);" (click)="moveB211orMoveB212(chatComment.member_id, chatComment.class_id)">{{ chatComment.organization_name }}</a>
                      <div class="datetime">
                        {{ chatComment.create_datetime }}
                      </div>
                    </div>
                    <div>
                      <!-- 投稿削除ボタン -->
                      <button
                        pButton
                        type="button"
                        label="削除"
                        class="delete-button"
                        (click)="delete(chatComment.board_id)"
                        *ngIf="decisionSecretariat()"
                      ></button>
                    </div>
                  </div>
                  <div class="chat-comment">
                    {{ chatComment.board_comment }}
                  </div>
                </div>

                <!-- チャットブロック(不適切) -->
                <div
                  class="unsuitable-chat-block"
                  *ngIf="0 == chatComment.status"
                >
                  <div class="name">
                    <div class="p-d-flex">
                      {{ chatComment.organization_name }}
                      <div class="datetime">
                        {{ chatComment.create_datetime }}
                      </div>
                    </div>
                  </div>
                  <div class="chat-comment">
                    不適切な文言が含まれる為、削除致しました。
                  </div>
                </div>
              </div>
            </p-scrollPanel>
          </div>
          <!-- 送信エリア -->
          <div class="p-d-flex p-ai-center send-area">
            <!-- 送信コメント -->
            <input
              type="text"
              pInputText
              class="send-inputtext"
              [formControl]="chat_comment"
            />
            <!-- 送信ボタン -->
            <button
              pButton
              type="button"
              icon="pi pi-send"
              label="送信"
              class="button1 send-button"
              (click)="send()"
              [disabled]="!chat_comment.valid"
            ></button>
          </div>
        </ng-template>
      </p-accordionTab>
    </p-accordion>
  </div>
</p-dialog>
